import { Injectable } from '@angular/core';
import { DadoIndiceDesenvolvimentoHumanoDto } from '../../dtos/dado-indice-desenvolvimento-humano';
import { CaqRequestService } from '../'
import { map, firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

interface ListDadoIndiceDesenvolvimentoHumano {
  _embedded: {
    'indices-desenvolvimento-humano': DadoIndiceDesenvolvimentoHumanoDto[];
  };
}

@Injectable({
  providedIn: 'root',
})
export class DadoIndiceDesenvolvimentoHumanoService {
  public urlBase = `${environment.apiUrl}/indices-desenvolvimento-humano`;

  constructor(private caqRequestService: CaqRequestService) {}

  async pegaDadoIndiceDesenvolvimentoHumano(): Promise<DadoIndiceDesenvolvimentoHumanoDto[]> {
    return firstValueFrom(this.caqRequestService
      .get<ListDadoIndiceDesenvolvimentoHumano>(this.urlBase)
      .pipe(map((response) => response._embedded['indices-desenvolvimento-humano'])));
  }
}
